import { gql } from "@apollo/client";

const UserValidations = gql`
  mutation checkUser($email:String! $tournament:Int! $category:Int! $primaryEmail:String ) {
    checkValidations2(email: $email, tournament: $tournament, category: $category primaryEmail:$primaryEmail)
  }
`;

export default UserValidations;
